<template>
  <div class="helper_wrap">
    <a-spin :spinning="loading">
      <div class="searchContainer" ref="searchRef">
        <div class="search-item">
          <a-input
            class="search-input"
            v-model:value="listQuery.selectErpId"
            @input="inputFormat($event, 'selectErpId', 4)"
            size="large"
            placeholder="BD ERP编号"
            allowClear
            :maxLength="20"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-input
            class="search-input"
            v-model:value="listQuery.name"
            size="large"
            placeholder="BD姓名"
            allowClear
            :maxLength="20"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-range-picker
            size="large"
            v-model:value="dateList"
            :placeholder="['服务开始日期', '服务结束日期']"
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            :allowClear="false"
          />
        </div>
        <div class="search-item">
          <a-input
            class="search-input"
            v-model:value="listQuery.phone"
            @input="inputFormat($event, 'phone', 3)"
            size="large"
            placeholder="BD手机号"
            allowClear
            :maxLength="15"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" @click="resetQuery">重置</a-button>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" type="primary" @click="doSearch">
            搜索
          </a-button>
        </div>
      </div>
      <div class="container">
        <div class="data_wrap">
          <div class="title">
            <span
              v-for="(it, index) in titles"
              :key="it.hid"
              :class="{ actived: activeTitle === it.hid }"
              @click="DrillingData(it)"
            >
              {{ it.hname }}
              <span class="split_flag" v-if="index !== titles.length - 1">/</span>
            </span>
          </div>
          <a-tabs type="card" v-model:activeKey="activeKey" @change="handleChange">
            <a-tab-pane v-for="item in dataTypeOptions" :key="item.key" :tab="item.title">
              <a-table
                class="table"
                :pagination="pagination"
                :rowKey="(record, index) => index"
                :columns="currentColumns"
                :data-source="tableData"
                @change="onChangePage"
                :scroll="{ x: `calc(100% - 40px)`, y: `calc(100vh - ${sHeight}px )` }"
                :transformCellText="({ text }) => text ?? '--'"
                :sortDirections="['descend', 'ascend']"
              >
                <template #hname="{ record }">
                  <!-- 医生电话号码 -->
                  <span
                    class="link_content"
                    v-if="record.hname && record.idType === 1"
                    @click="DrillingData(record)"
                    :class="{ disabled: record.idType !== 1 }"
                  >
                    {{ record.hname }}
                  </span>
                  <span v-else-if="record.hname && record.idType === 2">
                    {{ record.hname }}
                    <auth-img :src="idcard" @click="seeInfo(record.hid)" class="see_detail" />
                  </span>
                  <span v-else>{{ record.hname || '--' }}</span>
                </template>
                <template #recordCnt="{ record }">
                  <!-- 备案客户数 -->
                  <span
                    class="link_content"
                    @click="bindUserInfo(record, 'bd', record.recordCnt)"
                    :class="{ disabled: record.idType !== 2 }"
                  >
                    {{ record.recordCnt }}
                  </span>
                </template>
                <template #bindPatientNum="{ record }">
                  <!-- 绑定患者人数 -->
                  <span
                    class="link_content"
                    v-if="record.bindPatientNum !== null"
                    @click="bindUserInfo(record, 'bdBindPatient', record.bindPatientNum)"
                    :class="{ disabled: record.idType !== 2 }"
                  >
                    {{ record.bindPatientNum }}
                  </span>
                  <span v-else>--</span>
                </template>
              </a-table>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </a-spin>
    <Details ref="detailsRef" />
    <UserInfo ref="userInfoRef" />
  </div>
</template>
<script>
export default { name: 'helper' }
</script>
<script setup>
import { reactive, ref, onMounted, nextTick, computed } from 'vue'
import { dataTypeOptions, paginationConfig, columnsOfService, columnsOfPerformance } from './config'
import { inputRule } from '@/utils/validate'
import { getbdList, getServiceData } from '@/api/UserPool'
import moment from 'moment'
import { formatDateForFilter } from '@/utils'
import Details from '@/views/UserPool/components/Details'
import idcard from '@/assets/img/idcard.png'
import UserInfo from '@/views/UserPool/components/UserInfo'
import { SearchOutlined } from '@ant-design/icons-vue'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { useStore } from 'vuex'
import { cloneDeep } from 'lodash-es'

const searchRef = ref(null)
const detailsRef = ref(null)
const userInfoRef = ref(null)
const activeKey = ref(0) // 0服务数据 1业绩数据
const activeTitle = ref(null)
const loading = ref(false)
const defaultQuery = {
  name: undefined, // bd姓名
  selectErpId: null, // erp编号
  endDate: '', //结束时间
  idType: null, // 0-汇总数据 1-部门 2-BD 3-医生
  hId: null,
  startDate: '', //结束时间
  dateType: 0,
  statType: 0,
  sortType: null, // ("1 升序 2 降序")
  SortFieldName: '', // 排序字段
  content: '', // 组织架构链路
  phone: null // bd手机号
}
const titles = ref([{ hname: '全部', hid: null, idType: null }])
const initDateList = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
const dateList = ref([...initDateList])
// 动态生成带排序状态的columns
const getColumnsWithSortOrder = (baseColumns, sortFieldName, sortType) => {
  if (!sortFieldName || !sortType) return baseColumns
  return baseColumns.map(col => {
    if (col.dataIndex === sortFieldName) {
      return {
        ...col,
        sortOrder: sortType === 1 ? 'ascend' : 'descend'
      }
    }
    return col
  })
}

const helperPoolDataMap = {
  // 服务数据
  0: {
    columns: columnsOfService,
    method: getServiceData
  },
  // 业绩数据
  1: {
    columns: columnsOfPerformance,
    method: getbdList
  }
}

const currentColumns = ref(helperPoolDataMap[0].columns)

const listQuery = reactive({ ...defaultQuery })
const pagination = reactive({ ...paginationConfig })
const tableData = ref([])
const sHeight = ref(60)
const store = useStore()
const defaultCacheQuery = {
  ...defaultQuery,
  dateList: [...initDateList],
  current: paginationConfig.current,
  pageSize: paginationConfig.pageSize,
  activeKey: 0,
  titles: [{ hname: '全部', hid: null, idType: null }]
}
const { initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.BD_POOL_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultCacheQuery,
  normalize: params => ({
    ...cloneDeep(defaultCacheQuery),
    ...cloneDeep(params),
    dateList: Array.isArray(params?.dateList) ? params.dateList : [...initDateList]
  })
})

const getPureQuery = () => {
  return Object.keys(defaultQuery).reduce((acc, key) => {
    acc[key] = listQuery[key]
    return acc
  }, {})
}

const applyCacheQuery = cacheQuery => {
  const queryCache = { ...cacheQuery }
  ;['dateList', 'current', 'pageSize', 'activeKey', 'titles'].forEach(key => {
    Reflect.deleteProperty(queryCache, key)
  })
  Object.assign(listQuery, defaultQuery, queryCache)
  ;['dateList', 'current', 'pageSize', 'activeKey', 'titles'].forEach(key => {
    Reflect.deleteProperty(listQuery, key)
  })
  dateList.value = cacheQuery.dateList || [...initDateList]
  pagination.current = cacheQuery.current || paginationConfig.current
  pagination.pageSize = cacheQuery.pageSize || paginationConfig.pageSize
  activeKey.value = Number(cacheQuery.activeKey || 0)
  titles.value = cacheQuery.titles || [{ hname: '全部', hid: null, idType: null }]
  activeTitle.value = titles.value[titles.value.length - 1]?.hid || null
}

const persistCache = () => {
  updateCache({
    ...getPureQuery(),
    dateList: dateList.value,
    current: pagination.current,
    pageSize: pagination.pageSize,
    activeKey: activeKey.value,
    titles: titles.value
  })
}

function resetQuery() {
  Object.assign(listQuery, defaultQuery)
  dateList.value = [...initDateList]
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  resetTitle()
  persistCache()
  searchList()
}
function doSearch() {
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  if (listQuery.selectErpId || listQuery.name) {
    listQuery.idType = null
    listQuery.hId = null
    resetTitle()
  }
  persistCache()
  searchList()
}
function searchList() {
  loading.value = true
  const [startDate, endDate] = formatDateForFilter(dateList.value, true)
  listQuery.content = titles.value
    .map(it => it.hid)
    .filter(it => !!it)
    .reverse()
    .join(',')
  const params = {
    ...getPureQuery(),
    pageNo: pagination.current,
    pageSize: pagination.pageSize,
    startDate,
    endDate
  }
  const method = helperPoolDataMap[activeKey.value].method
  method(params)
    .then(res => {
      const { list = [], totalCount } = res
      tableData.value = list
      pagination.total = totalCount
      pagination.showTotal = () => `共${totalCount}条`
    })
    .catch(() => {
      tableData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}
function resetTitle() {
  titles.value = [{ hname: '全部', hid: null, idType: null }]
  activeTitle.value = null
}
function handleChange() {
  // 切换tab时重置排序状态
  listQuery.sortType = null
  listQuery.SortFieldName = ''
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  currentColumns.value = helperPoolDataMap[activeKey.value].columns
  persistCache()
  searchList()
}
const disabledDate = current => {
  // Can not select days before today and today
  return !(current && current < moment().endOf('day'))
}
function inputFormat(e, key, type) {
  listQuery[key] = inputRule(e.target.value, type)
}
const onChangePage = (page, filters, sorter) => {
  const { field, order } = sorter
  if (order === 'descend') {
    // 降序
    listQuery.sortType = 2
    listQuery.SortFieldName = field
  } else if (order === 'ascend') {
    // 升序
    listQuery.sortType = 1
    listQuery.SortFieldName = field
  } else {
    listQuery.sortType = null
    listQuery.SortFieldName = ''
  }
  // 更新 columns 的排序状态显示
  currentColumns.value = getColumnsWithSortOrder(
    helperPoolDataMap[activeKey.value].columns,
    listQuery.SortFieldName,
    listQuery.sortType
  )
  pagination.current = page.current
  pagination.pageSize = page.pageSize
  persistCache()
  searchList()
}
// 数据下钻
const DrillingData = record => {
  const { hid, hname, idType } = record
  const list = titles.value
  const index = list.findIndex(it => it.hid === hid)
  if (index !== -1) {
    // 往上一层点击的话则隐藏
    list.splice(index + 1, list.length - 1)
  } else {
    if (idType !== 1) return
    list.push({
      hid,
      hname,
      idType
    })
  }
  titles.value = list
  activeTitle.value = hid
  listQuery.hId = hid
  listQuery.idType = idType
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  persistCache()
  searchList()
}
const bindUserInfo = (row, key, num) => {
  const { idType } = row // id类型 0-汇总数据 1-部门 2-BD 3-医生
  if (idType !== 2 || !num) return
  row.mode = key
  detailsRef?.value?.initModal(row)
}
const seeInfo = id => {
  const params = {
    accountType: 3,
    id
  }
  userInfoRef?.value.initModal(params)
}
const getHeight = () => {
  nextTick(() => {
    sHeight.value = (searchRef?.value?.clientHeight || 60) + 340
  })
}
onMounted(() => {
  getHeight()
  // applyCacheQuery(initFromCache())
  // 恢复排序状态显示
  currentColumns.value = getColumnsWithSortOrder(
    helperPoolDataMap[activeKey.value].columns,
    listQuery.SortFieldName,
    listQuery.sortType
  )
  searchList()
})
</script>
<style scoped lang="scss">
.helper_wrap {
  height: 100%;
}
.searchContainer {
  background-color: #fff;
  padding: 10px 20px 0;
  .search-item {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 12px;
    .search_icon {
      color: rgba(0, 0, 0, 0.45);
    }
  }
}
.container {
  margin: 20px;
}
.data_wrap {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  height: 100%;

  .title {
    font-weight: 400;
    font-size: 14px;
    color: #00000066;
    margin-bottom: 17px;
    span {
      cursor: pointer;
      &:hover {
        color: #1890ff;
      }
    }
    .actived {
      color: #000000e0;
    }
    .split_flag {
      margin: 0 5px;
    }
  }
  .link_content {
    &.disabled {
      color: #333;
    }
  }
  .see_detail {
    width: 20px;
    height: 20px;
    margin-left: 4px;
    cursor: pointer;
  }
}
</style>
